exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searcher-bar {\n  position: relative;\n}\n\n.searcher-content {\n  margin-top: 0;\n}\n\n.searcher-content .searcher-bar .fa-times {\n  right: 15px;\n}\n\n.searcher-content .searcher-bar .fa-search {\n  left: 15px;\n  z-index: 1;\n}\n\n.searcher-content .read-only {\n  padding-left: 40px;\n}\n\n.search-results-container {\n  left: 15px !important;\n  right: 15px !important;\n  width: auto;\n}\n\n\n.search-results-container {\n\n  margin: 0;\n  z-index: 1010;\n  position: absolute;\n  top: auto;\n  left: 0 !important;\n  width: 80%;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  background: #ffffff;\n  color: #343434;\n  border: solid 1px #ecf0f4;\n  box-shadow: 4px 4px 3px 0 rgba(0, 0, 0, 0.12);\n\n  -webkit-transiton: opacity 0.2s;\n  -moz-transition: opacity 0.2s;\n  -ms-transition: opacity 0.2s;\n  -o-transition: opacity 0.2s;\n  -transition: opacity 0.2s;\n\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.search-results-container .search-results-body {\n  margin: 15px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/crear-codigo/crear-codigo.component.css
// module id = ../../../../../src/app/pages/admin/crear-codigo/crear-codigo.component.css
// module chunks = main